import {CreditNote} from '../../../types/CreditNote/CreditNote';
import {MenuItem} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import CreditNoteService from '../../../services/CreditNoteService';
import React, {ReactNode} from 'react';

const CreditNoteDownloadAction = React.forwardRef<HTMLLIElement, {
  creditNote: CreditNote;
  closeMenu: () => void;
  label?: ReactNode;
}>(({
  creditNote,
  closeMenu,
  label,
}, ref) => {
  const { t } = useTranslation('creditNotes');

  const downloadCreditNote = () => {
    CreditNoteService.downloadCreditNote(creditNote.id);
  };

  return (
    <MenuItem
      ref={ref}
      onClick={() => {
        downloadCreditNote();
        closeMenu();
      }}
    >
      {label ? label : t('download pdf')}
    </MenuItem>
  );
});

export default CreditNoteDownloadAction;
